import { render, staticRenderFns } from "./lvPrice.vue?vue&type=template&id=84a6b2ba&scoped=true&"
import script from "./lvPrice.vue?vue&type=script&lang=js&"
export * from "./lvPrice.vue?vue&type=script&lang=js&"
import style0 from "./lvPrice.vue?vue&type=style&index=0&id=84a6b2ba&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a6b2ba",
  null
  
)

export default component.exports